import axios from 'axios'
import util from './util'
import mdui from 'mdui'
import store from '../store'
import router from '../router'

let tmpDialog

//正式环境
let TICKET_QCA_URL = 'https://ticketapi.xzsmartmetro.com'
let QCA_URL = 'https://qcaapi.xzsmartmetro.com'
let EXTP_URL = 'https://extp.xzsmartmetro.com'
//测试环境
// let TICKET_QCA_URL = 'https://testticketapi.xzsmartmetro.com'
// let QCA_URL = 'https://testqcaapi.xzsmartmetro.com'
// let EXTP_URL = 'https://extp.dev.smartmetro.tech/exapi'

axios.interceptors.request.use(config => { // 这里的config包含每次请求的内容
  config.headers[`iTPS-TOKEN`] = `${util.getUserToken()}`
  config.headers[`X-Merchant-Identity`] = `${util.getMerchantIdentity()}`
  return config
}, err => {
  return Promise.reject(err)
})

function getUrlVars (url) {
  var hash
  var myJson = {}
  var hashes = url.slice(url.indexOf('?') + 1).split('&')
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=')
    myJson[hash[0]] = hash[1]
  }
  return myJson
}

axios.interceptors.response.use(response => {
  return response
}, error => {
  mdui.snackbar({
    message: error.message === 'Network Error' ? '网络异常，请检查网络！' : error.message,
    position: 'bottom'
  })
  return Promise.resolve(error)
})

function checkStatus (response) {
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 ||
      response.status === 400)) {
    return response
  }
  // 异常状态下，把错误信息返回去
  return {
    Code: -404,
    message: '网络异常，请检查网络！'
  }
}

function checkCode (res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === -404) {
    // mdui.snackbar({
    //     message: res.message,
    //     position: 'bottom'
    // })
    return res.data
  }
  if (res.data) {
    switch (res.data.Code) {
      case 4206:
        store.commit('setToken', '')
        util.setUserToken('')
        if (!tmpDialog) {
          tmpDialog = mdui.dialog({
            title: '提示',
            content: '登录过期，请重新登录',
            history: false,
            buttons: [
              {
                text: '确认',
                onClick: function (inst) {
                  router.push({ path: '/exchange', query: getUrlVars(location.search) })
                  tmpDialog = null
                }
              }
            ]
          })
        }
        res.data.Message = ''
        break
      case 4403:
        mdui.snackbar({
          message: '验证码错误，请确认验证码',
          position: 'bottom'
        })
        res.data.Message = ''
        break
      case 4300:
        if (!tmpDialog) {
          tmpDialog = mdui.dialog({
            title: '提示',
            content: `验证失败，请确认Code(${getUrlVars(location.search).code})`,
            history: false,
            buttons: [
              {
                text: '确认',
                onClick: function (inst) {
                  tmpDialog = null
                }
              }
            ]
          })
        }
        res.data.Message = ''
        break
      case 4731:
        mdui.snackbar({
          message: '兑换码无效，请输入正确的兑换码',
          position: 'bottom'
        })
        res.data.Message = ''
        break
      case 4730:
        mdui.snackbar({
          message: '请输入兑换码',
          position: 'bottom'
        })
        res.data.Message = ''
        break
      case 4734:
        mdui.snackbar({
          message: '兑换码已使用，请更换兑换码',
          position: 'bottom'
        })
        res.data.Message = ''
        break
      case 4723:
        mdui.snackbar({
          message: '活动状态错误',
          position: 'bottom'
        })
        res.data.Message = ''
        break
    }
  }
  return res.data
}

const $axios = {
  post (url, data, item) { //  post
    let headers = {
      'content-type': 'application/json; charset=UTF-8'
    }
    switch (item) {
      case 'ticket':
        url = TICKET_QCA_URL + url
        break
      case 'extp':
        url = EXTP_URL + url
        headers['x-channel'] = 1;
        break
      default:
        url = QCA_URL + url
        break
    }
    return axios({
      method: 'post',
      url,
      data: data,
      timeout: 20000,
      headers: headers
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    ).catch(e => console.log(e))
  },
  get (url, params, item) { // get
    let headers = {
      'content-type': 'application/json; charset=UTF-8'
    }
    switch (item) {
      case 'ticket':
        url = TICKET_QCA_URL + '/' + url
        break
      case 'extp':
        url = EXTP_URL + url
        headers['x-channel'] = 1
        break
      default:
        url = QCA_URL + '/' + url
        break
    }
    return axios({
      method: 'get',
      url,
      params, // get 请求时带的参数
      timeout: 20000,
      headers: headers
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  }
}
// 请求方式的配置
export default {
  install (Vue, options) {
    Vue.prototype.$axios = $axios
  },
  $axios
}
